import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var Tick = createSvgIcon(React__default.createElement("path", { d: "M21.271 6.13876L10.5086 19.0956L3.30469 12.0918L4.69884 10.6578L10.3521 16.154L19.7325 4.86084L21.271 6.13876Z" }), 'Tick');

export { Tick };
